var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-layout"},[_c('user-header'),_c('user-menu',{staticClass:"user-menu"}),_c('div',{staticClass:"main-content"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }